import { useState } from "react";
import { useToast } from "./Toast";
import Dropzone from "react-dropzone";
import axios from "axios";
import {
  UPLOAD_TEMP_GUEST_LIST_API,
  UPLOAD_TEMP_LOW_END_GUEST_LIST_API,
} from "../Constant/api";
import LoadingInComponent from "./LoadingInComponent";

const FileUpload = ({ handleChange, lowEndMode = false }) => {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleUploadFile = (acceptedFiles) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    const eventId = sessionStorage.getItem("event_id");
    axios
      .post(
        lowEndMode
          ? UPLOAD_TEMP_LOW_END_GUEST_LIST_API
          : UPLOAD_TEMP_GUEST_LIST_API,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            event_id: eventId,
          },
        },
      )
      .then((res) => {
        setLoading(false);
        handleChange(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        const errorMessage = err.response?.data?.message || "Failed to upload file";
        toast(errorMessage, "error");
      });
  };

  const handleRejectedFiles = (rejectedFiles) => {
    rejectedFiles.forEach((file) => {
      if (file.errors.some((e) => e.code === "file-too-large")) {
        toast("File is too large. Maximum size is 5MB.", "error");
      } else {
        toast("File type not accepted.", "error");
      }
    });
  };

  return (
    <LoadingInComponent isLoading={loading}>
      <Dropzone
        onDropAccepted={handleUploadFile}
        onDropRejected={handleRejectedFiles}
        accept={{
          "application/vnd.ms-excel": [".xls"],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
            ".xlsx",
          ],
          "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
          "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
          "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
            [".xltx"],
          "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
          "text/csv": [".csv"],
        }}
        maxSize={5000000}
        className="w-full h-full border-black"
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragAccept,
          isDragReject,
        }) => {
          const additionalClass = isDragAccept
            ? "border-green-500"
            : isDragReject
              ? "border-red-500"
              : "border-[#EFF0F2]";

          return (
            <section className="flex w-full">
              <div
                {...getRootProps()}
                className={`flex flex-col border w-full h-[76px] justify-center items-center cursor-pointer rounded-lg ${additionalClass}`}
              >
                <input {...getInputProps()} />
                {isDragActive ? (
                  isDragAccept ? (
                    <p className="text-[#636C7E] font-normal">
                      Drop the files here ...
                    </p>
                  ) : (
                    <p className="text-[#636C7E] font-normal">
                      File type not accepted!
                    </p>
                  )
                ) : (
                  <p className="text-[#636C7E] font-normal">
                    Drag & Drop your files or{" "}
                    <span className="text-[#5C4BF5] font-medium">Browse</span>
                  </p>
                )}
              </div>
            </section>
          );
        }}
      </Dropzone>
    </LoadingInComponent>
  );
};

export default FileUpload;
